var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-40 h-24 p-2 rounded-full flex items-center cursor-pointer",class:{
    'bg-black justify-start': !_vm.value,
    'bg-blue-500 justify-end': _vm.value,
  },on:{"click":_vm.emitCheckboxChange}},[_c('div',{staticClass:"h-20 w-20 rounded-full bg-white pill",class:{ active: _vm.value }})])
}
var staticRenderFns = []

export { render, staticRenderFns }